import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class CreateNewScheduleLoyaltyTitle extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("ScheduleLoyaltyDiscountTitle/Create");
  }
  setFormData(data) {
    super.setFormData(data);
  }
}

class GetScheduleLoyaltyTitleList extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("ScheduleLoyaltyDiscountTitle/GetList");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class UpdateASingleScheduleLoyaltyDiscountTitle extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("ScheduleLoyaltyDiscountTitle/Update");
  }
  setFormData(data) {
    super.setFormData(data);
  }
}

class DeleteASingleScheduleLoyaltyTitle extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("ScheduleLoyaltyDiscountTitle/Delete");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetAllScheduleLoyaltyTitlesLite extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("ScheduleLoyaltyDiscountTitle/GetLightList");
  }
}

export {
  CreateNewScheduleLoyaltyTitle,
  GetScheduleLoyaltyTitleList,
  UpdateASingleScheduleLoyaltyDiscountTitle,
  DeleteASingleScheduleLoyaltyTitle,
  GetAllScheduleLoyaltyTitlesLite,
};
